<template>
  <Card dis-hover>
    <div slot="title">
      <slot name="title"></slot>
      <p class="title-item">{{ this.$t('common.this_month') }}</p>
    </div>
    <!-- <a href="#" slot="extra">
      <slot name="extra"></slot>
    </a> -->
    <div id="content"></div>
    <Spin size="large" v-if="SummaryItem === {}" fix></Spin>
  </Card>
</template>
<script>
import * as echarts from 'echarts';
import api from '../../../api/home/index';
import { tooltipRefash } from '../echartUtil';
export default {
  data() {
    return {
      sortWay: 'top',
      myChart: null,
      timer: null,
    };
  },
  props: {
    SummaryItem: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    this.getData();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    myEchartsResize() {
      this.myChart && this.myChart.resize();
    },
    // 获取巡店基本情况数据
    getData() {
      let params = {
        timeRange: 5,
        tagIdList: [],
        sourceTypeList: [],
        showCompare: 0,
        deptNode: [],
        checkerType: 2,
        role: [],
        user: [],
        templateId: [],
      };
      api
        .shopBaseSummary(params)
        .then(res => {
          // 初始化echarts
          this.initEcharts(res);
        })
        .catch(error => {
          console.log('err:', error);
          this.$Message.error(`error`);
        });
    },
    initEcharts(resInfo) {
      // 基于准备好的dom，初始化echarts实例
      //console.log(resInfo, 'resInfo--');
      let myChart = echarts.init(document.getElementById('content'), null, { renderer: 'svg' });
      let ScoreList = this.getScoreList(resInfo);

      let legendData = ScoreList.map(item => item.name);
      let selectedLegend = {};
      for (let i in legendData) {
        if (legendData[i].indexOf(this.$t('common.unchecked')) > -1) {
          selectedLegend[legendData[i]] = false;
        } else {
          selectedLegend[legendData[i]] = true;
        }
      }
      let option = {
        color: ScoreList.map(item => item.color),
        tooltip: {
          show: true,
          trigger: 'item',
          position: 'right',
          formatter: function(a) {
            if (a.name) {
              return ` 
                    <div><span style="display:inline-block;width:12px;height:12px;margin-right:10px;border-radius:2px;background-color:${a.color}"></span>${a.name}</div>
                    <span>${a.value} ，</span><span>  ${a.data.showRate}% </span>
                      `;
            }
          },
        },
        grid: {
          left: '2%',
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          top: 'center',
          right: '0%',
          itemHeight: 12, //图例的高度
          itemWidth: 12,
          itemGap: 12, //图例之间的间距
          textStyle: {
            rich: {
              n: {
                display: 'inline-block',
                width: 80,
                color: '#E6E6E6',
              },
              v: {
                display: 'inline-block',
                marginLeft: 10,
                width: 40,
                color: '#E6E6E6',
              },
              s: {
                color: '#B2B2B2',
              },
            },
          },
          data: legendData,
          formatter: function(name) {
            let tarValue;
            let showRate;
            const data = ScoreList;
            for (let i = 0; i < data.length; i++) {
              if (data[i].name === name) {
                tarValue = data[i].value;
                showRate = data[i].showRate;
              }
            }
            return `{n|${name}}{v|${tarValue}}{s|${showRate}%}`;
          },
          selected: selectedLegend,
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['55%', '65%'],
            center: ['30%', '53%'],
            avoidLabelOverlap: true,
            label: {
              show: true,
              position: 'outside',
              formatter: function(params) {
                return `${params.data.showRate}%`;
              },
            },
            labelLine: {
              show: true,
              length: 6,
            },
            data: ScoreList,
          },
        ],
      };
      // 绘制图表
      myChart.setOption(option);
      this.myChart = myChart;
      let dataLen = option.series[0].data.length;
      this.timer = tooltipRefash(myChart, dataLen);
    },
    getScoreList(newVal) {
      let { uncover } = newVal;
      let total = newVal.gearVos.reduce((cur, pre) => {
        return cur + pre.num;
      }, 0);
      total += uncover;
      let otherTotalRate = 0;
      let arr = newVal.gearVos.map(item => {
        const value = item.num / total || 0;
        const showRate = value === 0 ? 0 : (Math.round(value * 100000) / 1000).toFixed(2) || 0;
        otherTotalRate += Number(showRate);
        return {
          name: item.gearName,
          value: item.num,
          color: item.color,
          leftScore: item.leftScore,
          rightScore: item.rightScore,
          showRate,
        };
      });
      arr.push({
        name: this.$t('common.unchecked'),
        value: uncover,
        color: '#cccccc',
        showRate: (100 - otherTotalRate).toFixed(2),
      });
      return arr;
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep {
  .ivu-card-head p {
    width: auto;
  }
}
.title-item {
  padding: 0 5px;
  height: 18px;
  background: rgba(255, 255, 255, 0.11);
  border-radius: 3px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 12px;
  color: #b2b2b2;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
  margin-left: 6px;
}
.top-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title {
    display: inline-block;
    margin-right: 5px;
    font-weight: 600;
    font-size: 16px;
    color: #333333;
  }
}
#content {
  width: 100%;
  height: 100%;
}
</style>
